import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    prompt: z.string().optional().default(""),
    /**
     * Direction of the categories to generate:
     * - `outgoing`: expense categories (Budget)
     * - `incoming`: revenue categories (Commercialisation)
     */
    direction: z.enum(["incoming", "outgoing"]).optional().default("outgoing"),
    files: z
      .array(
        z.object({
          name: z.string(),
          mimeType: z.string(),
          content: z.string(), // Base64
        }),
      )
      .min(1)
      .max(1),
  }),
  response: z.array(
    z.object({
      name: z.string(),
      amount: z.number().nullable(),
      groupName: z.string().nullable(), // null means ungrouped
    }),
  ),
};
